import { render, staticRenderFns } from "./TopupsPaymentBulkUploadComponent.vue?vue&type=template&id=12b89fce&"
import script from "./TopupsPaymentBulkUploadComponent.vue?vue&type=script&lang=js&"
export * from "./TopupsPaymentBulkUploadComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports